var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNewFont(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 27,
    viewBox: "0 0 101 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.4051V0.625H4.94119L16.1484 17.8117V0.625H21.0896V26.4051H16.1484L4.94119 9.21835V26.4051H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6111 26.4051V0.625H38.3656V5.49456H27.4807V11.0802H36.2173V15.9498H27.4807V26.4051H22.6111Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9431 26.4051V5.17231H39.8152V0.625H60.9406V5.17231H52.8127V26.4051H47.9431Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.8652,
    y: 0.625,
    width: 4.64175,
    height: 25.4436,
    fill: "#0064FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68.5078,
    y: 8.70508,
    width: 4.64175,
    height: 4.64174,
    fill: "#0064FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1484,
    y: 4.0625,
    width: 4.64175,
    height: 4.64174,
    fill: "#0064FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 91.7148,
    y: 8.70508,
    width: 4.64175,
    height: 4.64174,
    fill: "#0064FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 91.7148,
    y: 8.70508,
    width: 4.64175,
    height: 4.64174,
    fill: "#0064FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 96.3574,
    y: 13.3477,
    width: 4.64175,
    height: 4.64174,
    fill: "#0064FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 91.7148,
    y: 17.9883,
    width: 4.64175,
    height: 4.64174,
    fill: "#0064FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 77.791,
    y: 21.7715,
    width: 4.64175,
    height: 4.64174,
    fill: "#0064FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 77.791,
    y: 8.70508,
    width: 4.64175,
    height: 13.0656,
    fill: "#0064FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 68.4492,
    y: 9.10547,
    width: 4.24061,
    height: 4.2406,
    fill: "#0064FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNewFont);
export default __webpack_public_path__ + "static/media/logo-new-font.c2b4977f7bcbb25a7610ca53fb92772d.svg";
export { ForwardRef as ReactComponent };